<div class="modal-header">
    <h4 class="modal-title">Create Pallet Labels</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    @if(orderPalletLabelsForm !== undefined && orderPalletLabelsForm !== null){
    <form [formGroup]="orderPalletLabelsForm">
        <div class="row mb-2">
            <div class="col-12">
                <label class="text-md-start">Quantity Type</label>
                <ng-select id="quantity-type" [items]="quantityTypes" bindLabel="name" bindValue="typeId" dropdownPosition="bottom"
                    (change)="onPalletLabelTypeChange($event.typeId)" formControlName="quantityType">
                </ng-select>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12">
                <label class="text-md-start">Number Of Labels</label>
                <input type="number" class="form-control" placeholder="Number Of Labels" name="numberOfLabels"
                    formControlName="numberOfLabels" id="number-of-labels" min="0" />
            </div>
        </div>
    </form>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="printLabels()">Print Label</button>
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Close</button>
</div>